import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const gcashDenominations = [
  { denomination: 5, points: 5 },
  { denomination: 10, points: 10 },
  { denomination: 20, points: 20 },
  { denomination: 50, points: 50 },
  { denomination: 75, points: 75 },
  { denomination: 100, points: 100 },
  { denomination: 150, points: 150 },
];

const Mechanics = () => {
  const classes = useStyles();
  return (
    <div className="Static">
      <h2 className="Static__heading">Mechanics</h2>
      <div className={classes.root}>
        <h4> How do I join the Shop Saya Rewards Program?</h4>
        <ul className="consent">
          <li>
            Purchase any of the participating SKU of Nutriasia and FPGMCEI
            products from the participating retailers
          </li>
          <li>
            Visit the Nutriasia Facebook Page
            (https://www.facebook.com/NutriAsia.Inc/)
          </li>
          <li>
            Initiate a Chat with the Nutriasia Rewards Chatbot by clicking on
            the Messenger icon and start a conversation with the Nutriasia
            Rewards Chatbot.
          </li>
          <li>
            Follow the provided steps and information required by the chatbot,
            including the GCash associated mobile number, promo terms and
            conditions and data privacy agreements.
          </li>
          <li>
            Upload any valid receipt showing the purchase of the participating
            Nutriasia and FPGMCEI Products SKUs and from the participating
            retailers
          </li>
          <li>
          Wait for the confirmation response from the chatbot
          </li>
        </ul>

        <h4> What’s a valid entry?</h4>
        <p>
          All entries are considered valid if the participant adheres to
          following:{" "}
        </p>
        <ul className="consent">
          <li>
            A clear receipt is uploaded to the Nutriasia Facebook Messenger
            Promo Chat
          </li>
          <li>
            The receipt contains a participating SKU purchased from an eligible
            retail outlet
          </li>
        </ul>

        <h4>How will I be able to earn Gcash?</h4>
        <p>Instant Rewards:</p>
        <ul className="consent">
          <li>
            The first receipt scan after a successfully completed registration
            with a valid mobile number from a single account will be instantly
            rewarded P10 in Gcash
          </li>
        </ul>

        <p>Regular redemptions:</p>
        <ul className="consent">
          <li>
            Once the chatbot has validated the purchase through the uploaded
            receipt, uploader will be awarded the corresponding points and will
            be recorded in the chatbot system per Facebook account.
          </li>
          <li>
            Points may be used to redeem rewards anytime as long the account’s
            points meet the minimum requirement to redeem.
          </li>
          <li>
            Every P50 (Fifty pesos) spent in the receipt is equal to 1 (one)
            point.
          </li>
          <li>
            Every month, there are special featured booster products if when
            bought, will automatically award 5 (Five) points to the account.
          </li>
        </ul>

        <h4>How many times can I join?</h4>
        <p>
          Instant rewards: once only upon successful and complete registration
          to the program
        </p>
        <p>
          Regular redemptions: Multiple – as long as you meet the minimum
          required points to redeem, you can redeem anytime.
        </p>

        <h4>How will I be notified that I was able to successfully redeem?</h4>
        <p>
          Users will be notified through the Nutriasia chatbot where they
          submitted their receipts that they are able to redeem their prizes
          once their transaction to redeem is completed.
        </p>

        <h4>What are the GCASH denominations I can redeem?</h4>
        <TableContainer className="table" >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" className="header">DENOMINATIONS</TableCell>
                <TableCell align="center" className="header">POINTS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gcashDenominations.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{row.denomination}</TableCell>
                  <TableCell align="center">{row.points}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <h4>What are the partner retailers?</h4>
        <p>You can scan receipts from any of our retail partners nationwide:</p>

        <ul className="list">
          <li>SM Supermarket</li>
          <li>SM Hypermarket</li>
          <li>Savemore</li>
          <li>Marketplace</li>
          <li>Robinsons Supermarket</li>
          <li>Robinsons Easymart</li>
          <li>Puregold</li>
          <li>Gaisano</li>
          <li>Waltermart</li>
        </ul>

        <h4>What are the participating products?</h4>
        <ul className="list">
          <li> DATU PUTI ADOBO SERIES: SPICY (180ML/24) </li>
          <li> DATU PUTI ADOBO SERIES: PININYAHAN (180ML/24) </li>
          <li> DATU PUTI ADOBO SERIES: HUMBA (180ML/24) </li>
          <li> DATU PUTI ADOBO SERIES: GATA (180ML/24) </li>
          <li> DATU PUTI ADOBO SERIES: CLASSIC (180ML/24) </li>
          <li> UFC TAMIS ANGHANG H&S (320G/24) </li>
          <li> UFC BC REGULAR (530G/18) </li>
          <li> UFC BC REGULAR (4 KG/4) </li>
          <li> UFC BC REGULAR (320G/24) </li>
          <li> UFC BC REGULAR (2 KG/8) </li>
          <li> UFC BC REGULAR (1 KG/12) </li>
          <li> PAPA BC REGULAR (530G/18) </li>
          <li> PAPA BC REGULAR (4 KG/4) </li>
          <li> PAPA BC REGULAR (320G/24) </li>
          <li> PAPA BC REGULAR (2 KG/8) </li>
          <li> PAPA BC REGULAR (1 KG/12) </li>
          <li> JUFRAN BC REGULAR (320G/24) </li>
          <li> DATU PUTI BBQ-RRIFIC BARBEQUE MARINADE (144ML/24) </li>
          <li> UFC GOLDEN FIESTA BIG CRUNCH ORIGINAL (60G/72) </li>
          <li> UFC GF BIG CRUNCH FRY & SHAKE CHEESE (45G/24) </li>
          <li> UFC WHOLE MUSHROOMS (400G/24) </li>
          <li> UFC WHOLE MUSHROOMS (198G/48) </li>
          <li> UFC SLICED YOUNG CORN (425G/24) </li>
          <li> UFC PIECES & STEMS MUSHROOMS (400G/24) </li>
          <li> UFC PIECES & STEMS (198G/48) </li>
          <li> UFC GREEN PEAS (400G/24) </li>
          <li> UFC GREEN PEAS (155G/50) </li>
          <li> UFC CORN KERNELS (425G/24) </li>
          <li> UFC HAPI FIESTA VEGETABLE OIL (2L - SUP/6) </li>
          <li> UFC HAPI FIESTA VEGETABLE OIL (1L SUP/12) </li>
          <li> UFC GOLDEN FIESTA SOYA OIL (2 LITERS/6) </li>
          <li> UFC GOLDEN FIESTA SOYA OIL (1 LITER/12) </li>
          <li> UFC GOLDEN FIESTA CORN OIL (2 LITERS/6) </li>
          <li> UFC GOLDEN FIESTA CORN OIL (1 LITER/12) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (950ML/12) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (500ML/24) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (485ML/24) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (3.785 LITERS/6) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (250ML/48) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (2 LITERS/6) </li>
          <li> UFC GOLDEN FIESTA COOKING OIL (1 LITER/12) </li>
          <li> UFC GOLDEN FIESTA CANOLA OIL (2 LITERS/6) </li>
          <li> UFC GOLDEN FIESTA CANOLA OIL (1 LITER SUP/12) </li>
          <li> UFC GOLDEN FIESTA CANOLA OIL (1 LITER PET/12) </li>
          <li> UFC GOLDEN FIESTA CANOLA FRY HEALTHY PACK (1L PET/2x6) </li>
          <li> HFVO DUO PACK (1L SUP/2x6) </li>
          <li> JUFRAN THAI FISH SAUCE (750ML/12) </li>
          <li> DATU PUTI PATIS - PET (1 LITER/12) </li>
          <li> DATU PUTI PATIS (150ML/60) </li>
          <li> UFC GRAVY SA SARAP (50G/72) </li>
          <li> UFC HOT SAUCE (4KG/4) </li>
          <li> JUFRAN RED HOT CHILI SAUCE (165G/24) </li>
          <li> MANG TOMAS ALL AROUND SARSA - SIGA - PORK FREE (325G/24) </li>
          <li> MANG TOMAS ALL AROUND SARSA - SIGA (325G/24) </li>
          <li> MANG TOMAS ALL AROUND SARSA - REGULAR (550G/18) </li>
          <li> MANG TOMAS ALL AROUND SARSA - REGULAR (325G/24) </li>
          <li> MANG TOMAS ALL AROUND SARSA - REGULAR (100G/48) </li>
          <li> MANG TOMAS ALL AROUND SARSA - PORK FREE (550G/18) </li>
          <li> MANG TOMAS ALL AROUND SARSA - PORK FREE (325G/24) </li>
          <li> LOCALLY TAMARIND (240ML/24) </li>
          <li> LOCALLY TAMARIND (1 LITER/12) </li>
          <li> LOCALLY RIPE MANGO (240ML/24) </li>
          <li> LOCALLY POMELO (240ML/24) </li>
          <li> LOCALLY POMELO (1 LITER/12) </li>
          <li> LOCALLY PINK GUAVA (240ML/24) </li>
          <li> LOCALLY PASSION FRUIT (1 LITER/12) </li>
          <li> LOCALLY MANGOSTEEN (1 LITER/12) </li>
          <li> LOCALLY GUYABANO (240ML/24) </li>
          <li> LOCALLY GUYABANO (1 LITER/12) </li>
          <li> LOCALLY DRAGON FRUIT (1 LITER/12) </li>
          <li> LOCALLY DALANDAN (240ML/24) </li>
          <li> LOCALLY DALANDAN (1 LITER/12) </li>
          <li> LOCALLY CALAMANSI (240ML/24) </li>
          <li>DP OYSTERRIFIC OYSTER SAUCE (430G/18) </li>
          <li>DP OYSTERRIFIC OYSTER SAUCE (30G/144) </li>
          <li>DP OYSTERRIFIC OYSTER SAUCE (170G/24) </li>
          <li>DP OYSTERRIFIC OYSTER SAUCE (150G/24) </li>
          <li>UFC TS READY RECIPES MENUDO (200G/24) </li>
          <li> UFC TS READY RECIPES MECHADO (200G/24) </li>
          <li> UFC TS READY RECIPES CALDERETA (200G/24) </li>
          <li> UFC TS READY RECIPES AFRITADA (200G/24) </li>
          <li> UFC READY RECIPES MENUDO/AFRITADA MIX (50G/72) </li>
          <li> UFC READY RECIPES KARE-KARE MIX (45G/72) </li>
          <li> UFC READY RECIPES CURRY MIX (40G/72) </li>
          <li> UFC READY RECIPES CALDERETA MIX (55G/72) </li>
          <li> UFC SINIGANG SA SAMPALOK MIX (20G/96) </li>
          <li> DATU PUTI SOY SAUCE 1L SUP (1 LITER/12) </li>
          <li> DATU PUTI SOY SAUCE 1L PET (1 LITER/12) </li>
          <li> DATU PUTI SOY SAUCE - PET/PCON (385ML/24) </li>
          <li> DATU PUTI SOY SAUCE - PET (3.785 LITERS/4) </li>
          <li> DATU PUTI SOY SAUCE - PET (19 LITERS/1) </li>
          <li> DATU PUTI SOY SAUCE - PET (1.893 LITERS/8) </li>
          <li> DATU PUTI SOY SAUCE - GIN BOTTLE/PET (350ML/24) </li>
          <li>UFC SWAKTO PACK (500G/24)</li>
          <li>UFC SPAGHETTI SUPREME PARTY PACK (1KG/12)</li>
          <li>UFC SPAGHETTI SAUCE (500G/36)</li>
          <li>UFC SPAGHETTI SAUCE (1 KG/12)</li>
          <li>UFC OVERLOAD CSS CREAMY (200G/24)</li>
          <li>JUFRAN TOMATO KETCHUP SRIRACHA (285G/24)</li>
          <li>JUFRAN SRIRACHA HOT SAUCE (515G/12)</li>
          <li>UFC SWEET CHILI SAUCE (340G/24)</li>
          <li>JUFRAN SWEET CHILI SAUCE (330G/24)</li>
          <li>JUFRAN SWEET CHILI SAUCE (1KG/12)</li>
          <li>UFC TOMATO KETCHUP FOIL (3KG/4)</li>
          <li>UFC TOMATO SAUCE GUISADO (200G/24)</li>
          <li>UFC TOMATO SAUCE GUISADO (1 KG/12)</li>
          <li>UFC TOMATO SAUCE (3KG/4)</li>
          <li>UFC TOMATO SAUCE (200G/24)</li>
          <li>UFC TOMATO SAUCE (1KG/12)</li>
          <li>DATU PUTI WHITE VINEGAR 1L SUP (1 LITER/12)</li>
          <li>DATU PUTI WHITE VINEGAR 1L PET (1 LITER/12)</li>
          <li>DATU PUTI WHITE VINEGAR - PET/PCON (385ML/24)</li>
          <li>DATU PUTI WHITE VINEGAR - PET (3.785 LITERS/4)</li>
          <li>DATU PUTI WHITE VINEGAR - PET (1.893 LITERS/8)</li>
          <li>DATU PUTI WHITE VINEGAR - GIN BOTTLE/PET (350ML/24)</li>
          <li>DATU PUTI WHITE VINEGAR - CARBOUY (19 LITERS/1)</li>
          <li>DATU PUTI SPICED VINEGAR - GIN BOTTLE/PET (350ML/24)</li>
          <li>DATU PUTI SPICED VINEGAR (750ML/12)</li>
          <li>DATU PUTI PINOY SPICE (375ML/24)</li>
          <li>DATU PUTI PARES PACK (1 LITER X 2/6)</li>
          <li>DATU PUTI BBQ-RRIFIC BARBEQUE MARINADE (350ML/18)</li>
          <li>LOCALLY RIPE MANGO (1 LITER/12)</li>
          <li>LOCALLY PINK GUAVA (1 LITER/12)</li>
          <li>UFC INSTANT SOUPS: CREAM OF MUSHROOM (70G/36)</li>
          <li>UFC INSTANT SOUPS: CHICKEN AND CORN (60G/36)</li>
          <li>JUFRAN SWEET CHILI SAUCE (285G/24)</li>
          <li>DATU PUTI SUGAR CANE VINEGAR (4 LITERS/4)</li>
          <li>UFC CREAM STYLE CORN (425G/24)</li>
          <li>UFC COCONUT CREAM (400ML/24)</li>
          <li>DATU PUTI SOY SAUCE TOYOMANSI (250ML/30)</li>
          <li>DATU PUTI PATIS - GIN BOTTLE/PET (350ML/24)</li>
          <li>UFC FUN CHOW: KIMCHI (25G/48)</li>
          <li>UFC FUN CHOW: BULGOGI (25G/48)</li>
          <li>UFC FUN CHOW: BIBIMBAP (27G/48)</li>
          <li>DATU PUTI WHITE VINEGAR - PET (19 LITERS/1)</li>
          <li>UFC OVERLOAD CSS MEATY (250G/24)</li>
          <li>UFC OVERLOAD CSS CHEESY (200G/24)</li>
          <li>JUFRAN BC REGULAR (275G/24)</li>
          <li>UFC FUN CHOW: SEAFOOD YANG CHOW (20G/48)</li>
          <li>UFC FUN CHOW: MEATY YANG CHOW (20G/48)</li>
          <li>DATU PUTI TOYOMANSI (375ML/24)</li>
          <li>DATU PUTI SUGAR CANE VINEGAR (350ML/24)</li>
          <li>DATU PUTI RED CANE VINEGAR (1 LITER/12)</li>
          <li>AMIHAN WHITE VINEGAR (4 LITERS/4)</li>
          <li>UFC IODIZED SALT (1KG/12)</li>
          <li>UFC GF BIG CRUNCH FRY & SHAKE BBQ (45G/24)</li>
          <li>MANG TOMAS ALL AROUND SARSA - REGULAR (1KG SUP/10)</li>
          <li>UFC INSTANT SOUPS: CRAB AND CORN (60G/36)</li>
          <li>DATU PUTI WHITE VINEGAR - PCON (3.785 LITERS/4)</li>
          <li>JUFRAN SWEET CHILI SAUCE (90G/48)</li>
          <li>JUFRAN SRIRACHA HOT SAUCE (285G PET/24)</li>
          <li>UFC GINISANG BAGOONG SPICY (250G/24)</li>
          <li>UFC GINISANG BAGOONG REGULAR (250G/24)</li>
          <li>UFC HAPI FIESTA VEGETABLE OIL (500ML/24)</li>
          <li>LOCALLY DALANDAN 1L TETRA DUO (1 LITER/2x6)</li>
          <li>LOCALLY ORGANIC COCONUT WATER (330ML/24)</li>
          <li>UFC READY RECIPES PALABOK MIX (40G/72)</li>
          <li>UFC READY RECIPES GATA MIX (45G/72)</li>
          <li>UFC HAPI FIESTA VEGETABLE OIL (1L PET/12)</li>
          <li>LOCALLY IMMUNITY PACK GUYABANO 6S (240ML/4)</li>
          <li>LOCALLY IMMUNITY DALANDAN 6S (240ML/4)</li>
          <li>LOCALLY IMMUNITY CALAMANSI 6S (240ML/4)</li>
          <li>DATU PUTI SOY SAUCE TOYOMAGIC (250ML/30)</li>
          <li>DATU PUTI SOY SAUCE TOYOCHILI (250ML/30)</li>
          <li>PAPA TK REGULAR (320G/24)</li>
          <li>DATU PUTI WHITE VINEGAR - PCON (1.893 LITERS/8)</li>
          <li>DATU PUTI SUKANG TAGALOG (250ML/30)</li>
          <li>DATU PUTI SUKANG SINAMAK (250ML/30)</li>
          <li>DATU PUTI SUKANG ILOKO (250ML/30)</li>
          <li>LOCALLY ORGANIC COCONUT WATER (1 LITER/12)</li>
          <li>LOCALLY COCONUT WATER W/ PANDAN FLAVOR (1 LITER/12)</li>
          <li>UFC TOMATO SAUCE (115G/36)</li>
          <li>DATU PUTI THAI FISH SAUCE (265ML/24)</li>
          <li>DATU PUTI PATIS (15ML/240)</li>
          <li>DATU PUTI PREMIUM LITE SOY SAUCE (375ML/24)</li>
          <li>JUFRAN RED HOT CHILI SAUCE (100G/24)</li>
          <li>UFC SUPREMO PANCIT CANTON (400G/30)</li>
          <li>DATU PUTI SOY SAUCE - PCON (1.893 LITERS/8)</li>
          <li>UFC SUPER FIESTA COCONUT OIL (350ML/24)</li>
          <li>UFC SUPER FIESTA COCONUT OIL (1L SUP/12)</li>
          <li>UFC HAPI FIESTA COOKING OIL (1L - SUP/12)</li>
          <li>UFC SHAKE IT UP CHEESE (25G/24)</li>
          <li>UFC SHAKE IT UP BBQ (25G/24)</li>
          <li>UFC GOLDEN FIESTA COOKING OIL (100 ML/72)</li>
          <li>UFC TOMATO SAUCE GUISADO (115G/36)</li>
          <li>UFC WHOLE CORN KERNEL (185G/48)</li>
          <li>UFC PIECES & STEMS MUSHROOMS TWINPACK (400G/2x12)</li>
          <li>UFC HAPI FIESTA COOKING OIL (2L - SUP/6)</li>
          <li>UFC SHIITAKE MUSHROOMS (198G/48)</li>
          <li>MANG TOMAS ALL AROUND SARSA - SIGA (550G/18)</li>
          <li>UFC PICKLES SWEET RELISH BOT (250G/24)</li>
          <li>DATU PUTI PREMIUM CANE VINEGAR (375ML/24)</li>
          <li>UFC FUN CHOW: SEAFOOD YANG CHOW LINKS (20G/48)</li>
          <li>UFC FUN CHOW: MEATY YANG CHOW LINKS (20G/48)</li>
          <li>UFC BC RICH BLEND REVERSE BOT (320/24)</li>
          <li>UF GFCO SOYA 1LX12 PET 2021 (50ML/144)</li>
          <li>(2 DP SOY 1L + 1 DP FSH 150ML)/6</li>
          <li>(2 DP VIN 1L + 1 DP FSH 150ML)/6</li>
          <li>DATU PUTI VINSOY HDPE LIFTER (1.893LX4)</li>
          <li>JUFRAN BC REGULAR (4 KG/4)</li>

          <li>UFC HAPI FIESTA COOKING OIL (1L - PET/12)</li>
          <li>UFC HAPI FIESTA VEGETABLE OIL (200ML/48)</li>
          <li>UFC GOLDEN FIESTA COOKING OIL (50ML/144)</li>
          <li>DATU PUTI BREWED SOY SAUCE (265ML/24)</li>
          <li>DATU PUTI NATURAL CANE VINEGAR (265ML/24)</li>
          <li>UFC SUPER FIESTA COCONUT OIL (1L PET/12)</li>
          <li>UFC COCONUT CREAM (200ML/48)</li>
          <li>UFC QUESORAP CHEESE (160G/48)</li>
          <li>UFC GOLDEN FIESTA COOKING OIL (350ML/24)</li>
          <li>UFC GOLDEN FIESTA CANOLA OIL (485ML PET/24)</li>
          <li>UFC SUPER FIESTA COCONUT OIL (17KG/1)</li>
          <li>AMIHAN CANE VINEGAR (4 LITERS/4)</li>
          <li>SS VIN WHT 1893MLX8 HDPE</li>
          <li>SS VIN WHT 3785MLX4 HDPE</li>
          <li>SS VIN WHT 19000MLX1 CBY</li>
          <li>SS VIN CANE 1893MLX8 HDPE</li>
          <li>SS VIN CANE 3785MLX4 HDPE</li>
          <li>SS SCS 4KGX4 HDPE</li>
          <li>SS HOT SAUCE 100GX48 PET</li>
          <li>SS SCS 180GX24 BOT</li>
          <li>SS SCS 330GX24 BOT</li>
          <li>SS SCS EXTRA SPICY 330GX24 BOT</li>
          <li>SS SCS EXTRA SPICY 180GX24 BOT</li>
          <li>SS SOY SCE 500MLX24 HDPE</li>
          <li>SS SOY SCE 1000MLX12 PET</li>
          <li>SS SOY SCE 19000MLX1 CBY</li>
          <li>SS VIN WHT 1000MLX12 PET</li>
          <li>SS VIN CANE 1000MLX12 PET</li>
          <li>SS SOY SCE PREMIUM 1000MLX12 PET</li>
          <li>SS SOY SCE 1000MLX12 SUP</li>
          <li>SS SOY SCE 350MLX24 PET 2017-12</li>
          <li>SS VIN WHT 1000MLX12 SUP</li>
          <li>SS WOW SARAP 8GX12X48 SACH (POLYBAG)</li>
          <li>SS WOW SARAP 8GX3X180 SACH (TRIPID)</li>
          <li>SS FISH SCE REG 3785MLX4 PET</li>
          <li>SS VIN WHT 1893MLX8 PET</li>
          <li>SS VIN WHT 3785MLX4 PET</li>
          <li>SS VIN CANE 1893X8 PET</li>
          <li>SS VIN CANE 3785MLX4 PET</li>
          <li>SS SOY SCE 1893MLX8 PET</li>
          <li>SS SOY SCE 3785MLX4 PET</li>
          <li>OE WCS SAUCE 3785MLX4 HDPE</li>
          <li>OE WCS SAUCE 150MLX24 BOT</li>
          <li>OE WCS SAUCE HOT 3785MLX4 HDPE</li>
          <li>OE WCS SAUCE HOT 150MLX24 BOT</li>
          <li>SS OYSTER SAUCE 170GX24 BOT</li>
          <li>SS FISH SCE REG 750MLX12 BOT</li>
          <li>SS WOW SARAP 4GX12X60 SACH (POLYBAG)</li>
          <li>LT CHINESE SOY SCE REG 350MLX18 BOT</li>
          <li>LT CHINESE SOY SCE REG 750MLX12 BOT</li>
          <li>LT CHINESE SOY SCE 1.893LX8 PET</li>
          <li>LT CHINESE SOY SCE 3.785LX4 PET</li>
          <li>LT CHINESE SOY SCE LIGHT 750MLX12 BOT</li>
          <li>SS SCS EXTRA SPICY 340GX24 BOT</li>
          <li>SS SOY SCE 19000MLX1 PET</li>
          <li>SS VIN WHT 19000MLX1 PET</li>
        </ul>

        <h4>
          My receipts are valid and I have valid purchases but points weren’t
          awarded?
        </h4>
        <p>
          In the next steps, please click “Speak to a customer service agent” so
          we can attend to your concerns.
        </p>
      </div>
    </div>
  );
};

export default Mechanics;
